import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { BookOpen } from 'lucide-react';

export function DocAppsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['app-definitions'],
    queryFn: () => api.get('/api/apps/definition/list').then((r: any) => r.data),
  });

  const definitions = data?.query?.data ?? [];

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <BookOpen className="h-6 w-6" /> App Documentation
        </h1>
        <p className="text-gray-500">Learn about available applications and integrations</p>
      </div>

      {isLoading ? (
        <div className="text-center py-12 text-gray-500">Loading documentation...</div>
      ) : (
        <div className="space-y-6">
          {definitions.map((def: any) => (
            <Card key={def.app_definition_id || def.app_id}>
              <CardHeader>
                <div className="flex items-center gap-3">
                  <img
                    src={def.app_logo || '/assets/images/default/organization.png'}
                    alt={def.app_name}
                    className="w-12 h-12 rounded object-contain"
                  />
                  <div>
                    <CardTitle className="text-lg">{def.app_name}</CardTitle>
                    <p className="text-sm text-gray-500">
                      {def.auth_type ? `Auth: ${def.auth_type}` : 'Documentation'}
                    </p>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-gray-600">
                  {def.description || `${def.app_name} integration for Connectfy platform.`}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}